import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
const blogApi = {
  getFavoriteByUserId(params) {
    return axios.get(`${base.dev}/services/app/BLog/getFavoriteByUserId`, { params })
  },
  UploadBlog(params) {
    return axios.post(`${base.dev}/TokenAuth/UploadBlog/Upload/UploadBlog`, params)
  },
  CreateBlog(params) {
    return axios.post(`${base.dev}/services/app/BLog/Create`, params)
  },
  UpdateBlog(params) {
    return axios.post(`${base.dev}/services/app/BLog/Update`, params)
  },
  UpdateBLogName(params) {
    return axios.post(`${base.dev}/services/app/BLog/UpdateBLogName`, params)
  },
  getReprintedSource(params) {
    return axios.get(`${base.dev}/services/app/ReprintedSource/GetAll`, { params })
  },
  GetAllMyLogin(params) {
    return axios.get(`${base.dev}/services/app/BLog/GetAllMyLogin`, { params })
  },
  GetAll(params) {
    return axios.post(`${base.dev}/services/app/BLog/GetAll`, params)
  },
  UpdateIsShow(params) {
    return axios.get(`${base.dev}/services/app/BLog/UpdateIsShow`, { params })
  },
  Delete(params) {
    return axios.get(`${base.dev}/services/app/BLog/Delete`, { params })
  },
  Get(params) {
    return axios.get(`${base.dev}/services/app/BLog/Get`, { params })
  },
  GetMySubscribeList(params) {
    return axios.get(`${base.dev}/services/app/BLog/GetMySubscribeList`, { params })
  },
  GetIdByContent(params) {
    return axios.post(`${base.dev}/services/app/BLog/GetIdByContent`, params)
  },
  GetAllByUserId(params) {
    return axios.post(`${base.dev}/services/app/BLog/GetAllByUserId`, params)
  },
  SubscribeCreate(params) {
    return axios.post(`${base.dev}/services/app/Subscribe/Create`, params)
  },
  adminGetAll(params) {
    return axios.post(`${base.dev}/services/app/AdminBLog/GetAll`, params)
  },
  adminUpdateIsShow(params) {
    return axios.get(`${base.dev}/services/app/AdminBLog/UpdateIsShow`, { params })
  },
  adminDelete(params) {
    return axios.get(`${base.dev}/services/app/AdminBLog/Delete`, { params })
  },
  AdminForbiddenGetAll(params) {
    return axios.get(`${base.dev}/services/app/AdminForbidden/GetAll`, { params })
  },
  AdminForbiddenUpdate(params) {
    return axios.post(`${base.dev}/services/app/AdminForbidden/Update`, params)
  },
  AdminForbiddenCreate(params) {
    return axios.post(`${base.dev}/services/app/AdminForbidden/Create`, params)
  },
}
export default blogApi


// WEBPACK FOOTER //
// ./src/api/blog/blogApi.js